
import { Directive, ElementRef, HostListener, Input, Renderer2, AfterViewInit } from '@angular/core';
import { isMobileDevice } from 'axis-components/components/utilities';
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[axisSticky]'
})
export class StickyDirective implements AfterViewInit {
  private el: HTMLInputElement;

  private stickyClassBody = 'axis-sticky-body';
  private stickyClassCustom = 'axis-sticky-custom'; // placeholder, prevent undefined
  private stickyClassDefault = 'axis-sticky';
  private stickyOffset: number;
  private isMobile = false;
  private stickyPosition = -1;
  private stickyScrollUp = false;
  private previousScrollPosition = 0;
  private headerHeight = '';
  @Input() mobileWidth = 767;
  @Input() asideElement: HTMLElement;
  @Input()
  set axisSticky(stickyVal: number) {
    // sticky="n"
    this.stickyOffset = stickyVal || 0; // # pixels to scroll down until element sticks (default is here)
  }

  @Input()
  set axisStickyClassBody(stickyClassBodyAttr: string) {
    // stickyClassBody="class"
    this.stickyClassBody = stickyClassBodyAttr; // # class to add to body element
  }

  @Input()
  set axisStickyClass(stickyClassAttr: string) {
    // stickyClass="class"
    this.stickyClassCustom = stickyClassAttr; // # class to add to sticky element
  }

  @Input()
  set axisStickyScrollup(stickyScrollUp: boolean) { // axisStickyScrollup="true"
    this.stickyScrollUp = stickyScrollUp; // # if true, show sticky element on scroll up
  }

  @Input()
  set axisStickyScrollUp(stickyScrollup: boolean) { // axisStickyScrollup="true"
    this.stickyScrollUp = stickyScrollup; // # if true, show sticky element on scroll up
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.el = this.elementRef.nativeElement;
    this.isMobile = (window.innerWidth < this.mobileWidth) || isMobileDevice();
  }

  ngAfterViewInit() {

    if (this.stickyOffset === 0) {
      this.headerHeight = this.elementRef.nativeElement.getBoundingClientRect().height + 'px';
      this.addStickyHeight();
      if (this.asideElement) {
        this.addTopPosition();
      }
    }
  }
  private addStickyHeight() {

    const ele = document.getElementsByClassName('sticky-height');
    if (!ele || !ele[0]) {
      const div = this.renderer.createElement('div');
      this.renderer.addClass(div, 'sticky-height');
      this.renderer.setStyle(div, 'height', this.headerHeight);
      this.renderer.insertBefore(this.elementRef.nativeElement.parentElement, div, this.elementRef.nativeElement);
    }
    this.el.classList.add(this.stickyClassDefault, this.stickyClassCustom);
    document.body.classList.add(this.stickyClassBody);
  }
  private removeStickyHeight() {
    const ele = document.getElementsByClassName('sticky-height');
    if (ele && ele[0]) {
      this.renderer.removeChild(ele[0].parentElement, ele[0]);
    }
    this.el.classList.remove(this.stickyClassDefault, this.stickyClassCustom);
    document.body.classList.remove(this.stickyClassBody);
  }
  private scrollUp() {
    const isFixedBody = document.body.style.cssText.indexOf('fixed') >= 0 &&
      parseInt(document.body.style.top, 10) * (-1) >= this.stickyOffset;
    if (window.pageYOffset >= this.stickyOffset || isFixedBody) {
      this.addStickyHeight();
      if (window.pageYOffset < this.stickyPosition) {
        this.el.style.transform = 'translateY(0)';
      } else {
        this.el.style.transform = 'translateY(-100%)';
      }
    } else if (window.pageYOffset === 0) {
      this.removeStickyHeight();
      this.el.style.transform = 'translateY(0)';
    }
    this.stickyPosition = window.pageYOffset;
  }

  private displayHeader() {
    this.renderer.removeStyle(this.elementRef.nativeElement, 'transform');
    /*if (this.asideElement) {
      if (window.scrollY) {
        this.addTopPosition();
      } else {
        this.removeTopPosition();
      }
    }*/
  }

  private hideHeader() {
    this.renderer.setStyle(this.elementRef.nativeElement, 'transform', 'translateY(-100%)');
    /*if (this.asideElement) {
      this.addTopPosition();
    }*/
  }

  private addTopPosition() {
    if (this.asideElement.classList.contains('axis-sidebar-fixed')) {
      const element = this.asideElement.getElementsByTagName('button');
      if (element && element[0]) {
        this.renderer.setStyle(element[0].parentElement, 'top', this.headerHeight);
      }
      const sideBarContentElement = this.asideElement.getElementsByClassName('axis-sidebar-content')[0];
      if (sideBarContentElement) {
        this.renderer.setStyle(sideBarContentElement, 'top', this.headerHeight);
      }
    }
  }

  private removeTopPosition() {
    if (this.asideElement.classList.contains('axis-sidebar-fixed')) {
      const element = this.asideElement.getElementsByTagName('button');
      if (element && element[0]) {
        this.renderer.removeStyle(element[0].parentElement, 'top');
      }
      const sideBarContentElement = this.asideElement.getElementsByClassName('axis-sidebar-content')[0];
      if (sideBarContentElement) {
        this.renderer.removeStyle(sideBarContentElement, 'top');
      }
    }
  }

  private onScroll() {
    const isFixed = document.body.style.cssText.indexOf('fixed') >= 0
      && parseInt(document.body.style.top, 10) * -1 >= this.stickyOffset;
    if (window.pageYOffset >= this.stickyOffset || isFixed) {
      if (this.stickyClassBody) {
        this.addStickyHeight();
        if (this.asideElement) {
          this.addTopPosition();
        }
      }
    } else {
      this.removeStickyHeight();
      if (this.asideElement) {
        this.removeTopPosition();
      }
    }
  }

  @HostListener('window:scroll') // keep tight; executes on scroll
  fixElement() {
    if (this.stickyOffset !== 0) {
      this.isMobile = (window.innerWidth < this.mobileWidth) || isMobileDevice();
      if (this.isMobile && this.el.hasAttribute('axisstickyscrollup')) {
        this.headerHeight = this.elementRef.nativeElement.getBoundingClientRect().height + 'px';
        this.scrollUp();
        const currentScrollPostion = window.pageYOffset;
        if (this.previousScrollPosition > currentScrollPostion) { // scroll up
          this.displayHeader();
        } else { // scroll down
          this.hideHeader();
        }
        this.previousScrollPosition = currentScrollPostion;
      } else if (!(this.isMobile) && !(this.el.hasAttribute('axisstickyscrollup'))) {
        this.headerHeight = this.elementRef.nativeElement.getBoundingClientRect().height + 'px';
        this.onScroll();
      }
    }
  }
}
